import { useMemo } from "react";
import {
  XAxis,
  YAxis,
  ResponsiveContainer,
  AreaChart,
  Tooltip,
  Area,
  Legend,
} from "recharts";
// const data = [
//   { name: "January", profit: 400, revenue: 200, amt: 2400 },
//   { name: "February", profit: 405, revenue: 2400, amt: 2400 },
//   { name: "March", profit: 300, revenue: 400, amt: 2400 },
//   { name: "April", profit: 200, revenue: 800, amt: 2400 },
// ];
const data = [
  { name: "January", revenue: 200 },
  { name: "February", revenue: 2400 },
  { name: "March", revenue: 400 },
  { name: "April", revenue: 800 },
];

const AreaChartMonthly = () => {
  const revenue = useMemo(() => {
    return (
      data &&
      data.map(({ name, revenue }) => {
        return {
          name: name.substring(0, 3),
          revenue: revenue,
        };
      })
    );
  }, [data]);
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        width={500}
        height={400}
        data={revenue}
        margin={{ top: 20, right: 0, left: -15, bottom: 0 }}
      >
        <defs>
          {/* <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
          </linearGradient> */}
          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey="name" style={{ fontSize: "10px" }} />
        <YAxis
          axisLine={{ strokeWidth: "0" }}
          style={{ fontSize: "10px" }}
          // domain={[8000, 23000]}
        />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="revenue"
          stroke="#82ca9d"
          fillOpacity={1}
          fill="url(#colorPv)"
        />
        <Legend height={20} wrapperStyle={{ margin: "0 0 10px 0" }} />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AreaChartMonthly;
